export default rangesOfPerformance => {
    return rangesOfPerformance.map(rangeOfPerformance => {
        const { id, title, value, description } = rangeOfPerformance
        return {
            id,
            title,
            value: value || null,
            description: description || null,
        }
    })
}
